import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { ThemePalette } from '@angular/material/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'y42-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatProgressSpinnerModule],
})
export class ButtonComponent {
  @Input() color?: ThemePalette;
  @Input() type: HTMLButtonElement['type'] = 'button';
  @Input() id?: string | null;
  @Input() class?: string | null;
  @Input() compact?: boolean | null;

  @Input()
  pending?: boolean | null;

  @Input()
  disabled?: boolean | null;

  @HostBinding('style.pointer-events')
  get pointerEvents() {
    return this.disabled || this.pending ? 'none' : undefined;
  }
}
